// require('./bootstrap');

import Vue from 'vue'
import Slick from 'vue-slick';
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { videoPlayer } from 'vue-video-player'

// ikonice (jednu po jednu)
import faUser from '@fortawesome/fontawesome-free-solid/faUser';

fontawesome.library.add(faUser);

Vue.component('font-awesome-icon', FontAwesomeIcon);

const content = new Vue({
    el: '#content',
    components: {Slick, videoPlayer},
    data() {
        return {
            slickOptions: {
                slidesToShow: 7,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 2000,
                centerMode: false,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 332,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
            playerOptions: {
                // videojs options
                aspectRatio: "16:9",
                muted: true,
                language: 'en',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: "/video/1.mp4"
                }],
                poster: "/images/logo.png",
            },
            secondPlayer: {
                // videojs options
                muted: true,
                language: 'en',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: "/video/4.mp4"
                }],
                poster: "/images/logo.png",
            },
            thirdPlayer: {
                // videojs options
                muted: true,
                language: 'en',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: "/video/5.mp4"
                }],
                poster: "/images/logo.png",
            }
        };
    },
    name: 'Content',
});



// WEBPACK FOOTER //
// ./resources/assets/js/welcome.js